import { FILTERS } from './evidenceFilters';

export default {
  path: '/evidences/kh-sales',
  filters: [
    ...FILTERS,
  ],
};
